import { trackEvent } from '../tools'

export default {
  deliveryArrivedClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_arrived_ck',
      eventLabel: '订单配送中确认送达链接 - I arrived at the location按钮点击',
      attrs,
    })
  },

  deliveredShow(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivered_sw',
      eventLabel: 'Bapp订单成功送达界面曝光',
      attrs,
    })
  },

  deliveringClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_ck',
      eventLabel: 'B app订单页配送中页面热区曝光',
      attrs,
    })
  },

  deliveringCodeCompletedClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_codecompleted_ck',
      eventLabel: 'Bapp - 订单页配送中DC交餐码弹窗Complete the delivery按钮点击',
      attrs,
    })
  },

  deliveringCodeCompletedShow(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_codecompleted_sw',
      eventLabel: 'Bapp - DC交餐码弹窗Complete the delivery曝光',
      attrs,
    })
  },

  deliveringVerify2StepsShow(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_verify2steps_sw',
      eventLabel: '订单配送中确认送达链接 - verify2steps曝光',
      attrs,
    })
  },

  deliveringCompleteTheDeliveryClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_completethedelivery_ck',
      eventLabel: '订单配送中确认送达链接 - Complete the delivery按钮点击',
      attrs,
    })
  },

  deliveringDeliveredClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_delivered_ck',
      eventLabel: 'Bapp - 订单页配送中确认送达按钮点击',
      attrs,
    })
  },

  deliveringShow(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_sw',
      eventLabel: '订单页配送中页面曝光-确认送达链接',
      attrs,
    })
  },

  deliveringVerifyAndContinueClick(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_x_delivering_verifyandcontinue_ck',
      eventLabel: '订单配送中确认送达链接 - Verify and continue按钮点击',
      attrs,
    })
  },
}
